export default `
fragment ParagraphCooperatedDeclarationAdmin on ParagraphCooperatedDeclarationAdmin {
  uuid
  entityBundle
  declarationList {
    entity {
      uuid
      entityBundle
      title
      description {
        value
      } 
      enabled
      declarationType
    }
  }
}
`
